export const isMobileDevice = () => {
  // 1. Check User Agent
  const ua = navigator.userAgent;
  const isMobileUA = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua);

  // 2. Check Touch Points (Standard for modern mobile devices)
  const hasTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

  // 3. Check Media Query (Optional but recommended for 'small' screens)
  const isSmallScreen = window.matchMedia('(max-width: 1024px)').matches;

  // Logic: Must have mobile UA OR (Touch capability AND Small Screen)
  // This prevents desktop touchscreens (like a Surface) from being flagged as mobile.
  return isMobileUA || (hasTouch && isSmallScreen);
};


// WEBPACK FOOTER //
// ./src/utils/device.ts